<button
  type="button"
  class="btn overflow-hidden"
  [disabled]="disabled"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
  [matMenuTriggerFor]="singleSelectMenu"
>
  <ng-content></ng-content>
</button>

<mat-menu #singleSelectMenu="matMenu" class="users-search-menu">
  <ng-template matMenuContent="">
    <div class="menu-search mat-mdc-menu-item d-flex align-items-center shrink-0">
      <craft-icon class="svg-icon text-size-13 mr-10" name="search--search"></craft-icon>
      <input
        type="text"
        #searchInput
        (click)="$event.stopPropagation()"
        [placeholder]="searchPlaceholder"
        [formControl]="searchControl"
      />
    </div>
    <div class="menu-scroll menu-content">
      <button
        class="d-flex align-items-center"
        mat-menu-item=""
        craftDisableFocus
        *ngFor="let user of filteredItems | async; trackBy: identify"
        (click)="selectItem(user)"
        type="button"
      >
        <craft-user-icon class="d-flex shrink-0 mr-8" [user]="user"></craft-user-icon>
        <span class="ellipsis" [matTooltip]="user.fullName" [matTooltipShowDelay]="1000">
          {{ user.fullName }}
        </span>
        <span class="ellipsis company-name" [matTooltip]="user.companyName" [matTooltipShowDelay]="1000">
          {{ user.companyName }}
        </span>
      </button>
      <craft-preloader *ngIf="isPreloaderShow"></craft-preloader>
    </div>
  </ng-template>
</mat-menu>
